// extracted by mini-css-extract-plugin
module.exports = {"swatchContainer":"Swatch_swatchContainer__3hPHB","swatch":"Swatch_swatch__SUD4S"};